<div class="web-view">


    <div class="main-div" fxLayout="row wrap">


        <div class="bodyClass">

            <div class="headers">
                <h1 class="heading1">Welcome to Creatics - Let's Get Started!</h1>
                <p class="textClass1">Provide some of your important profile info now or skip and do later.
                </p>
                <a href="/userProfiles/{{userId}}/setup/2" class="skip" style="color:black"> <button class="skipbtn" 
                    appTrackClick
                    [buttonProps]="{
                        title:'setup_one_skip_button',
                        feature_context:'ONBOARDING'
                    }"
                    >Skip</button></a>

            </div>
            <hr>
            <h1 class="heading2">My Picture</h1>
            <p class="textClass">Please upload a picture of yourself
                or something you love. This personalizes your Creatics profile and
                helps people connect with you.
                <span class="required"><br>*(Required)</span>


            </p>


            <div   class="imgUpload" [ngClass]="imageBoxDisable ? 'imgUpload' : 'uncheckedClass'"
                (click)="image1.click();click()"    
              accept=".jpg, .jpeg,.png"
              appTrackClick
                [buttonProps]="{
                    title:'setup_one_my_picture_upload_button',
                    feature_context:'ONBOARDING'
                }"
              >

                <div >
                    <image-cropper *ngIf="stopCropper" [imageChangedEvent]="imgChangeEvt" [maintainAspectRatio]="true"
                        [aspectRatio]="4 / 4" [resizeToWidth]="256" format="png"
                        (imageCropped)="imageCropped($event,'image')" (imageLoaded)="imgLoad()"
                        (cropperReady)="initCropper()" (loadImageFailed)="imgFailed()">
                    </image-cropper>

                    <figure class="icons" input type="file" accept="image/*">

                        <input class="form-control" type="file" [disabled]="imageFlag" (change)="onFileChange($event)"
                            accept="image/*" #image1>
                        <div class="items-center">
                            <img *ngIf="!userProfile.profilePic && iconDisabled" src="assets\svg\photo icon.svg"  height="50">
                        </div>
                        <figcaption *ngIf="!userProfile.profilePic && iconDisabled" class="vdocaption" style="color:black" >Upload Profile Picture
                        </figcaption>
                        <img class="img" *ngIf="!stopCropper && !userProfile.profilePic"  [src]="cropImgPreview">
                        <img *ngIf="userProfile.profilePic" class="img"[src]="cropImgPreview">


                    </figure>
                </div>

            </div>
            <h5 class="heading3">Accepted file formats : jpg, png.</h5>
            <h5 class="heading3" style="margin:-1%;margin-left: 1%;">Size limit : 40 MB</h5>
            <button class="cropButton" *ngIf="cropButton"
                [ngStyle]="(clickedCrop) ? {'visibility': 'hidden'} : {'visibility': 'visible'} "
                [disabled]="!cropImgPreview"
                (click)="cropImage('image1')">

                CROP
            </button>
            <span aria-hidden="true" *ngIf="cropButton"
                [ngStyle]="(clickedCrop) ? {'visibility': 'hidden'} : {'visibility': 'visible', 'display':'inline-block'} "
                class="required" >*(MUST CROP BEFORE SUBMITTING)</span>
            <hr>


            <div>
                <h1 class="heading2">My Words</h1>


                <p class="textClass"> Use a few words to paint a picture of what you love.

                </p>
                <input class="inputbox1"maxlength="128" [(ngModel)]="imageText"
                    placeholder="EG (an ER doctor): Family, Medicine, Cooking, Writing Novels, NYCity (Upto 128 characters)">
                <hr>

            </div>

            <button class="submitbtn"
                [ngStyle]="submitButtonEnabled ?   {'cursor' :'pointer','opacity':'1'}:{'cursor': 'not-allowed','opacity':'0.65'}"
                [disabled]="!submitButtonEnabled"
                (click)="submitData(this.croppedImage,this.imageText)"
                 appTrackClick
                [buttonProps]="{
                    title:'setup_one_submit_button',
                    feature_context:'ONBOARDING'
                }"
                >Submit</button>

        </div>





    </div>

</div>